import { IDevice } from '@lib/axon/interfaces/device.interface';
import { SnLonLat } from '@lib/geo/helpers';

import { AxonUsherAlertModel } from '../models/axon-usher-alert.model';
import { HistoricalInterface } from './historical.interface';

export interface IBannerContent {
  data: AxonUsherAlertModel;
  icon: string;
}

export interface IDeviceMarker {
  id: string;
  device: IDevice;
  selected: boolean;
  updated: number;
  bannerContent: IBannerContent[];
  deviceHistory: HistoricalInterface[];

  hasHighPriorityHistory?: boolean;
  processHistoricalData?(historicalData: any): void;
  getIsCameraActive?(): boolean;
  getDeviceStatus(): string;
  isRecording(): boolean;
  isBuffering(): boolean;
  isInactive(): boolean;

  canStream(): boolean;
  getLonLat(): SnLonLat;
  getMarker(): google.maps.marker.AdvancedMarkerElement;
  setFollowMode(enabled: boolean): void;
  getFollowMode(): boolean;
}
